import { EventParams } from './interfaces';
import { log } from '../messaging';
import { MapboxProfile } from '@mapbox/mapbox-sdk/lib/classes/mapi-request';

type ParamsTuple<T> = T extends undefined ? [] : [T];

enum Event {
	FeedbackButtonClick = 'Clicked on rate us',
	DownloadButtonClick = 'Clicked on download',
	StopAdd = 'Added stop',
	ProfileChange = 'Changed profile'
}

interface ProfileChangeEvent {
	eventValue: MapboxProfile;
}

type Params = Omit<EventParams, 'eventAction' | 'eventCategory'>;

function createEvent<T extends Params | undefined = undefined>(eventAction: Event, initialParams?: Params) {
	return (...params: ParamsTuple<T>) => {
		log({
			eventAction,
			...Object.assign({}, initialParams, params[0]),
			eventCategory: 'Widget'
		});

		if (process.env.NODE_ENV === 'development') {
			console.log(`%c log %c ${eventAction} `, 'background: yellow; color: black', 'background: blue', ...params);
		}
	};
}

export const feedbackButtonClickEvent = createEvent(Event.FeedbackButtonClick);
export const downloadButtonClickEvent = createEvent(Event.DownloadButtonClick);
export const stopAddEvent = createEvent(Event.StopAdd);
export const profileChangeEvent = createEvent<ProfileChangeEvent>(Event.ProfileChange);
